export default __webpack_public_path__ + "static/media/ToolsArrow.d96356ac.svg";